function chartDataTypeToName(chartDataType) {
    switch (chartDataType) {
      case 'va_processes':
        return "VA processes";
      case 'nva_processes':
        return "NVA processes";
      case 'prof_and_hour_rate':
        return "Effective hourly rate & profitability";
      case 'va_and_nva':
        return 'VA & NVA';
      case 'process_group':
        return 'Process groups';
      case 'process_problems':
        return 'Process problems';
      case 'employee_role':
        return 'Employee role';
      case 'vol_slicer_table':
        return 'Volume slicer table';
      case 'vol_slicer_hours':
        return 'Volume slicer table - average time per unit';
      case 'vol_slicer_volume':
        return 'Volume slicer table - volume';
      default:
        return "All charts";
    }
  }

  function clientIdsToName(clientIds, dominantClient, hasAllClientsForGivenSpan) {
    if (hasAllClientsForGivenSpan) {
      return "all clients";
    } else if (!dominantClient) {
      return `${clientIds.length} client(s)`;
    } else {

      if (clientIds.length == 1)
        return `${dominantClient.clientName}`;
      else
        return `${dominantClient.clientName} and ${clientIds.length - 1} other client(s)`;
    }
  }

  function teamIdsToName(teamIds, dominantTeam, hasAllTeamsForGivenSpan) {
    if (hasAllTeamsForGivenSpan) {
      return "all teams";
    } else if (!dominantTeam) {
      return `${teamIds.length} team(s)`;
    } else {
      if (teamIds.length == 1)
        return `${dominantTeam.teamName}`;
      else
        return `${dominantTeam.teamName} and ${teamIds.length - 1} other team(s)`;
    }
  }

  export function entryToName(entry) {
    const generalName = chartDataTypeToName(entry.chartDataType);
    const whose = clientIdsToName(entry.clientIds, entry.dominantClientView, entry.hasAllClientsForGivenSpan);
    const whom = teamIdsToName(entry.teamIds, entry.dominantTeamView, entry.hasAllTeamsForGivenSpan);

    return `${generalName} for ${whose} by ${whom}`;
  }